import { render, staticRenderFns } from "./StatsGlobales_Admin.vue?vue&type=template&id=8a342ece&"
import script from "./StatsGlobales_Admin.vue?vue&type=script&lang=js&"
export * from "./StatsGlobales_Admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports